export default [
  { name: 'getOpeningTag', regex: /(<(([a-z0-9\-]+:)?[a-z0-9\-]+))/ig },
  { name: 'getText', regex: /([^<]+)/g },
  { name: 'getClosingTag', regex: /(<\/(([a-z0-9\-]+:)?[a-z0-9\-]+)>)/ig },
  { name: 'getCommentOpen', regex: /(<!\-\-)/g },
  { name: 'getComment', regex: /(([\s\S]*?)\-\->)/g },
  { name: 'getScript', regex: /(([\s\S]*?)<\/script>)/g },
  { name: 'getTagEnd', regex: /(\s*(\/?>))/g },
  { name: 'getAttributeName', regex: /(\s+(([a-z0-9\-_]+:)?[a-z0-9\-_]+)(\s*=\s*)?)/ig }
].reduce((pre, item) => {
  pre[item.name] = function (str, pos) {
    item.regex.lastIndex = pos
    var match = item.regex.exec(str)
    if (!match || match.index !== pos) {
      return undefined
    } else {
      return {
        length: match[1].length,
        match: match
      }
    }
  }
  return pre
}, {
  getOpeningTag: function(str, pos) {},
  getText: function(str, pos) {},
  getClosingTag: function(str, pos) {},
  getCommentOpen: function(str, pos) {},
  getComment: function(str, pos) {},
  getScript: function(str, pos) {},
  getTagEnd: function(str, pos) {},
  getAttributeName: function(str, pos) {},
})


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/tokenizer/chunk.js